import { timer as observableTimer, Observable } from 'rxjs';

import { takeWhile } from 'rxjs/operators';
import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BasePageComponent } from '../../../base-page.component';
import { ReportPdfModel, ReportItem } from '../../models/index';
import { ReportService, ApplicationService } from '../../services/index';

@Component({
    templateUrl: './report-pdf-list.component.html',
    standalone: false
})
export class ReportPdfListPageComponent extends BasePageComponent implements OnInit, OnDestroy {
  reports: ReportPdfModel[];
  errorMessage: string;
  public loading: Boolean = true;
  private alive: boolean;
  private newReports: ReportPdfModel[] = [];
  public itemId: string;
  public title: string;
  public sendReport = true;

  constructor(
    public reportService: ReportService,
    public applicationService: ApplicationService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    location: Location,
    public cdf: ChangeDetectorRef
  ) {
    super(location);
    this.alive = true;
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.itemId = params['itemId'];

      observableTimer(0, 5000)
        .pipe(takeWhile(() => this.alive))
        .subscribe(() => {
          this.reportService.getReports(this.itemId).subscribe((reports: ReportPdfModel[]) => {
            this.dataInit(reports);
          });
        });
    });
    this.cdf.detectChanges();
  }

  downloadReport(item: ReportItem) {
    if (item.status === 200) {
      this.reportService.downloadReport(item.id);
    }
  }

  shareReport(report: ReportPdfModel) {
    if (report.status === 200) {
      return this.router.navigate([this.inspectionsRoute, this.itemId, 'reports', report.id, 'share']);
    }
  }

  private addNewReport(reports: ReportPdfModel[]) {
    this.newReports.push(...reports);
  }

  private detectNewReports(report: ReportPdfModel) {
    if (this.newReports.some((r) => r.name === report.name)) {
      report.isNew = true;
    }
  }

  private dataInit(reports: ReportPdfModel[]) {
    let newReports: ReportPdfModel[] = null;
    if (this.reports) {
      newReports = reports.filter(
        (r) => !this.reports.some((report) => report.name === r.name && report.status === r.status) && r.status === 200
      );
    }
    if (newReports) {
      this.addNewReport(newReports);
    }
    this.reports = reports;
    this.reports.forEach((r) => this.detectNewReports(r));
    this.loading = false;
  }

  ngOnDestroy() {
    this.alive = false;
  }

  selectMenu(e: any) {}
}
